export const LOAN_SECTION_KEYS = {
  ADVANCES_AND_RESERVES: "advances-and-reserves",
  SECTION_ADDITIONAL_ADVANCES: "section-additional-advances",
  SECTION_ESCROW_RESERVE: "section-escrow-reserve",
  CLOSING_COSTS: "closing-costs",
  COVENANTS_AND_OTHER_DETAILS: "covenants-and-other-details",
  FINANCIAL_COVENANTS: "financial-covenants",
  CASH_MANAGEMENT: "cash-management",
  LEASING: "leasing",
  DEFINITIONS: "definitions",
  LOAN_ECONOMICS: "loan-economics",
  GENERAL_INFORMATION: "general-information",
  AMORTIZATION: "amortization",
  EXTENSIONS: "extensions",
  FINANCIAL_REPORTING: "financial-reporting",
  BORROWERDOCS: "borrower-docs",
  GUARANTORDOCS: "guarantor-docs",
  BORROWERREPORTING: "borrower-reporting",
  ADDBORROWERREPORTINGBUTTON: "add-borrower-reporting-button",
  GUARANTORREPORTING: "guarantor-reporting",
  ADDGUARANTORREPORTINGBUTTON: "add-guarantor-reporting-button",
  CASHMANAGEMENTGENERAL: "cash-management-general",
  CASHMANAGEMENTREPORTING: "cash-management-reporting",
  ADDCASHMANAGEMENTREPORTINGBUTTON: "add-cash-management-reporting-button",
  FINANCIALMISCELLANEOUS: "financial-miscellaneous",
  FINANCIAL_CASH_MANAGEMENT: "financial-cash-management",
  GUARANTOR: "guarantor",
  PERSONAL_GUARANTORS: "personalGuarantors",
  COMPANY_GUARANTORS: "companyGuarantors",
  GUARANTY: "guaranty",
  HEDGE_REQUIREMENTS: "hedge-requirements",
  INSURANCE: "insurance",
  MISCELLANEOUS: "miscellaneous",
  PARTIAL_RELEASE: "partial-release",
  PROPERTY_ALLOCATIONS: "property-allocations",
  QUOTE_HISTORY: "quote-history",
  VIEW_QUOTE_HISTORY: "view-quote-history",
  LOAN_PREPAYMENT_DETAILS: "prepayment-details",
  LOAN_PREPAYMENT_SCHEDULE: "prepayment-schedule",
  LOAN_FORBEARANCE: "loan-forbearance",
  LOAN_ASSUMPTIONS: "loan-assumptions",
  FINANCIAL_REPORTING_GENERAL: "financial-reporting-general"

};
